const splitTemplatesByRecommendation = (templates) =>
  templates.reduce(
    (acc, template) => {
      if (template.properties.recommended) {
        acc.recommendedTemplates.push(template);
      } else {
        acc.restTemplates.push(template);
      }
      return acc;
    },
    { recommendedTemplates: [], restTemplates: [] }
  );

export default splitTemplatesByRecommendation;
